import React from 'react';
import clsx from 'clsx';

export const GradientSpinner = ({
  size = 'md',
  className = '',
  blueGradient = { from: 'blue-600', to: 'blue-500' },
  purpleGradient = { from: 'purple-600', to: 'purple-500' },
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8 border-[3px]',
    md: 'h-12 w-12 border-4',
    lg: 'h-16 w-16 border-[6px]',
  };

  return (
    <div className={clsx('flex justify-center items-center', className)}>
      <div
        className={clsx(
          'rounded-full border-transparent animate-spin',
          `border-t-${blueGradient.from}`,
          `border-r-${blueGradient.to}`,
          `border-b-${purpleGradient.from}`,
          `border-l-${purpleGradient.to}`,
          sizeClasses[size]
        )}
      />
    </div>
  );
};
